import { PRODUCTS, SIZES, THEMES, BRANDS, FEATURED, REVIEWS, SHOW_REVIEWS, FAQ, SALE_RATE, WAS_RATE, HERO_VIDEO, HERO_LINES, BRAND } from './data.js?v=25';
import { posterURL } from './posters.js?v=25';
import { initSignupPopup } from './popup.js?v=25';

const $ = (s, r = document) => r.querySelector(s);
const app = $('#app');
const money = (n) => `$${n.toFixed(2)} USD`;
const unit = (l) => (l.custom ? (l.framed ? l.size.customFramed : l.size.custom) : (l.framed ? l.size.framed : salePrice(l.size.price)));
const lineWas = (l) => unit(l) / WAS_RATE;
const lineLabel = (l) => (l.custom ? `${l.custom.orient === 'l' ? `${l.size.h}x${l.size.w}` : `${l.size.w}x${l.size.h}`} cm` : l.size.label) + (l.framed ? ' · Framed canvas' : '');
const salePrice = (n) => SIZES.find((s) => s.price === n)?.sale ?? Math.round(n * SALE_RATE * 4) / 4;
const stars = '★★★★★';
const PAGE_SIZE = 12;
const byHandle = (h) => PRODUCTS.find((x) => x.handle === h);

const cart = [];
const CART_KEY = 'pw-cart';
const saveCart = () => { try { localStorage.setItem(CART_KEY, JSON.stringify(cart.filter((l) => !l.custom).map((l) => ({ h: l.p.handle, s: l.size.id, q: l.qty, f: l.framed ? 1 : 0 })))); } catch (e) { /* storage blocked */ } };
const loadCart = () => {
  try {
    JSON.parse(localStorage.getItem(CART_KEY) || '[]').forEach(({ h, s, q, f }) => {
      const p = PRODUCTS.find((x) => x.handle === h);
      const size = SIZES.find((x) => x.id === s);
      if (p && size && q > 0) cart.push({ p, size, qty: q, framed: !!f });
    });
  } catch (e) { /* corrupt or blocked: start empty */ }
};
loadCart();
let viewer = null;
const state = { theme: null, brand: null, sort: 'best', page: 1 };

/* ---------- Gallery wall: a fresh random set on every visit, then one frame swaps now and then ---------- */
const shuffle = (list) => { const r = [...list]; for (let i = r.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [r[i], r[j]] = [r[j], r[i]]; } return r; };
// Only the standard 2:3 posters go on the wall, so the five frames line up neatly whatever is picked.
const wallPool = () => PRODUCTS.filter((p) => p.ratio > 0.64 && p.ratio < 0.7);
const wallPicks = () => shuffle(wallPool()).slice(0, 5);
let wallTimer = null;
function startWall() {
  clearInterval(wallTimer);
  const row = document.querySelector('.gw__row');
  if (!row || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  wallTimer = setInterval(() => {
    if (document.hidden) return;
    const r = row.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return; // only swap while it is on screen
    const items = [...row.children].filter((el) => !el.matches(':hover'));
    const shown = new Set([...row.children].map((el) => el.dataset.handle));
    const next = shuffle(wallPool().filter((p) => !shown.has(p.handle)))[0];
    if (!items.length || !next) return;
    const el = items[Math.floor(Math.random() * items.length)];
    const img = el.querySelector('img');
    img.style.opacity = 0;
    setTimeout(() => {
      img.onload = () => { img.style.opacity = 1; };
      img.src = posterURL(next); img.alt = next.title;
      el.href = `#/product/${next.handle}`; el.dataset.handle = next.handle; el.setAttribute('aria-label', next.title);
      if (img.complete) img.style.opacity = 1;
    }, 450);
  }, 3600);
}

/* ---------- shared bits ---------- */
function card(p) {
  const base = SIZES[0].price;
  return `<a class="card" href="#/product/${p.handle}">
    <span class="card__heart${wishHas(p.handle) ? ' is-on' : ''}" role="button" tabindex="0" data-wish="${p.handle}" aria-pressed="${wishHas(p.handle)}" aria-label="Save ${p.title} to wishlist">${IC.heart}</span>
    <div class="card__media"><div class="card__frame" style="--r:${p.ratio}"><img src="${posterURL(p)}" alt="${p.title} poster" loading="lazy"></div></div>
    <h3 class="card__title">${p.title}</h3>
    <div class="price"><s>${money(base)}</s><b>From ${money(salePrice(SIZES[0].price))}</b></div>
  </a>`;
}

function newsletter() {
  return `<section class="newsletter"><h2>Stay in the pit lane</h2><p>New drops, styling tips and exclusive offers. No spam.</p>
    <form><input type="email" required placeholder="Email address" aria-label="Email"><button>SUBSCRIBE</button></form></section>`;
}

function usp() {
  return `<div class="usp">
    <div><div class="num">01</div><h3>Printed to order</h3><p>Every poster is printed on canvas after you order, so each one is made fresh for you.</p></div>
    <div><div class="num">02</div><h3>Free shipping</h3><p>Dispatched within 2 days and delivered in about 10-15 days, with free shipping on every order.</p></div>
    <div><div class="num">03</div><h3>Covered if it goes wrong</h3><p>If your order is lost or arrives damaged, we will refund it.</p></div></div>`;
}

/* ---------- hero video ---------- */
// One pre-rendered file (black and white, blurred, crossfaded, seamless loop): see media/hero-loop.mp4.
// Shuffle the home headline on every load, remembering the last one so it never repeats back to back.
const HERO_LINE = (() => {
  let last = -1;
  try { last = Number(localStorage.getItem('pw-hero-line')); } catch (e) { /* storage blocked */ }
  let i;
  do { i = Math.floor(Math.random() * HERO_LINES.length); } while (HERO_LINES.length > 1 && i === last);
  try { localStorage.setItem('pw-hero-line', String(i)); } catch (e) { /* storage blocked */ }
  return HERO_LINES[i];
})();

function hero(kind = 'page', o = {}) {
  const home = kind === 'home';
  const n = PRODUCTS.length;
  return `<section class="hero ${home ? 'hero--home' : 'hero--page'}"><div class="hero__media"><video class="hero__video" src="${HERO_VIDEO}" autoplay muted loop playsinline preload="auto" aria-hidden="true"></video></div>
    <div class="hero__content">
      <div class="hero__eyebrow">${o.eyebrow ?? (home ? `${BRAND.name.charAt(0)}${BRAND.name.slice(1).toLowerCase()} prints` : 'The collection')}</div>
      <${home ? 'h1' : 'h2'} class="hero__title">${o.title ?? (home ? HERO_LINE : 'Every car, <em>one wall.</em>')}</${home ? 'h1' : 'h2'}>
      <p class="hero__lede">${o.lede ?? (home ? `${n} hypercars, icons and race cars. Printed to order, shipped free.` : `From hypercars to Le Mans legends: all ${n} prints in one place.`)}</p>
      ${home ? '<a class="btn-hero" href="#/collection"><span>Shop the collection</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' : ''}
    </div></section>`;
}

// Browsers can ignore autoplay on re-render; nudge it, and honour reduced motion.
function startHero() {
  const v = document.querySelector('.hero__video');
  if (!v) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); return; }
  v.play().catch(() => {});
}

/* ---------- pages ---------- */
const SOCIALS = [
  ['Instagram', 'instagram', '#E4405F'], ['TikTok', 'tiktok', '#111111'], ['Pinterest', 'pinterest', '#BD081C'],
  ['Facebook', 'facebook', '#0866FF'], ['YouTube', 'youtube', '#FF0000'], ['X', 'x', '#111111'],
];
const socialRow = () => SOCIALS.map(([n, f, c]) => `<a class="soc" href="#" aria-label="${n}" title="${n}" style="--i:url(${window.PWA('social/' + f + '.svg')});--c:${c}"><i></i></a>`).join('');

function follow() {
  return '';
  return `<section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">More from Pitwall</div><h2 class="serif">Follow us &amp; <em>discover more</em></h2><p>New drops, wall inspiration and behind-the-scenes. Find us on every platform.</p></div>
    <div class="follow__row">${socialRow()}</div>
    <p class="follow__handle">@pitwallprints on all platforms</p>
  </div></section>`;
}


function statsOf(p) {
  return [['Power', p.hp && `${p.hp} hp`], ['0–60 mph', p.zero60 && `${p.zero60} s`], ['Top speed', p.top && `${p.top} mph`], ['Torque', p.tq && `${p.tq} lb-ft`]].filter(([, v]) => v).slice(0, 3);
}

function homeA() {
  const best = FEATURED.best.slice(0, 6).map(byHandle).filter(Boolean);
  const sp = byHandle(FEATURED.spotlight) || PRODUCTS[0];
  const roomPicks = [[ROOMS[0], byHandle('ferrari-f40')], [ROOMS[1], byHandle('bugatti-chiron')]];
  const count = (b) => PRODUCTS.filter((p) => p.brand === b).length;
  return `
  ${hero('home')}
  <div class="perks-bar"><div class="wrap perks-bar__in">
    <div>${IC.paper}<span><b>Printed to order</b><small>Made fresh for you</small></span></div>
    <div>${IC.truck}<span><b>Free shipping</b><small>On every order</small></span></div>
    <div>${IC.clock}<span><b>Ships in 2 days</b><small>Arrives in about 10–15</small></span></div>
    <div>${IC.frame}<span><b>Three sizes</b><small>30×40 · 40×50 · 50×70 cm</small></span></div>
  </div></div>

  <section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Shop by style</div><h2 class="serif">Find your <em>kind of fast.</em></h2></div>
    <div class="tiles">${[...THEMES, '__all'].map((t) => {
      if (t === '__all') return `<a class="tile" href="#/collection" style="--bgimg:url(../${posterURL(byHandle('ferrari-enzo'))})"><span>All posters</span></a>`;
      const p = byHandle(FEATURED.themes[t]) || PRODUCTS.find((x) => x.theme === t);
      return `<a class="tile" href="#/collection?theme=${t}" style="--bgimg:url(../${posterURL(p)})"><span>${t}</span></a>`;
    }).join('')}</div>
  </div></section>

  <section class="section home-best"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Bestsellers</div><h2 class="serif">Most loved <em>prints</em></h2></div>
    <div class="grid">${best.map(card).join('')}</div>
    <div style="text-align:center"><a class="btn-ghost btn-ghost--ink" href="#/collection">View all ${PRODUCTS.length} posters</a></div>
  </div></section>

  <section class="spot"><div class="wrap spot__in">
    <a class="spot__art" href="#/product/${sp.handle}" aria-label="${sp.title}"><div class="spot__frame" style="--r:${sp.ratio}"><img src="${posterURL(sp)}" alt="${sp.title} poster" draggable="false"></div></a>
    <div class="spot__copy">
      <div class="eyebrow">Poster of the moment</div>
      <h2 class="serif">${sp.brand} <em>${sp.model}</em></h2>
      <p class="spot__fact">${sp.fact || `${sp.variant}, ${sp.years}.`}</p>
      <dl class="spot__stats">${statsOf(sp).map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}</dl>
      <a class="btn-hero btn-hero--dark" href="#/product/${sp.handle}"><span>View the print</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
    </div>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">In your space</div><h2 class="serif">See it on <em>your wall</em></h2><p>Every print comes in three sizes, S 30×40 cm, M 40×50 cm and L 50×70 cm, made to fit standard frames.</p></div>
    <div class="rooms">${roomPicks.map(([room, p]) => `<a class="room" href="#/product/${p.handle}">${wallScene(room, p)}<span class="room__cap">${p.title}</span></a>`).join('')}</div>
  </div></section>

  <section class="section section--soft"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Browse by brand</div><h2 class="serif">Your favorite <em>makers</em></h2></div>
    <div class="brandchips">${BRANDS.map((b) => `<a class="brandchip" href="#/collection?brand=${encodeURIComponent(b)}">${b}<small>${count(b)}</small></a>`).join('')}</div>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">How it works</div><h2 class="serif">From screen to wall in <em>three steps</em></h2></div>
    <ol class="steps">
      <li><span class="steps__n">01</span><h3>Choose your print</h3><p>Browse ${PRODUCTS.length} posters and pick the size that suits your space.</p></li>
      <li><span class="steps__n">02</span><h3>We print it to order</h3><p>Every poster is printed on canvas after you order and dispatched within 2 days.</p></li>
      <li><span class="steps__n">03</span><h3>It arrives ready to hang</h3><p>Free shipping, delivered in about 10–15 days. Sold unframed, sized for standard frames.</p></li>
    </ol>
  </div></section>

  ${SHOW_REVIEWS ? `<section class="section section--soft"><div class="wrap"><div class="section__head"><div class="eyebrow">Reviews</div><h2>Join 25,000 happy customers</h2></div>
    <div class="reviews">${REVIEWS.map((r) => `<div class="review"><div class="stars">${stars}</div><p>${r.text}</p><small>${r.name}</small></div>`).join('')}</div></div></section>` : ''}
  ${follow()}
  ${newsletter()}`;
}

// ---- Home B: gallery-wall concept (Home A above is kept as the first design) ----
function homeB() {
  const best = FEATURED.best.map(byHandle).filter(Boolean);
  const wall = wallPicks(); // five random posters, the middle frame is the biggest
  const fresh = [...best.slice(6), ...PRODUCTS.filter((p) => !best.includes(p)).slice(0, 4)].slice(0, 8);
  const marq = BRANDS.map((b) => `<a href="#/collection?brand=${encodeURIComponent(b)}">${b}</a>`).join('<i>✦</i>');
  const feature = byHandle(FEATURED.spotlight) || PRODUCTS[0];
  return `
  ${hero('home')}
  <div class="marq" aria-label="Brands"><div>${marq}<i>✦</i>${marq}<i>✦</i></div></div>

  <section class="gw"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Curated for you</div><h2 class="serif">Build a wall <em>worth stopping for</em></h2><p>Mix sizes, mix eras, and hang a few legends side by side.</p></div>
    <div class="gw__row">${wall.map((p, i) => `<a class="gw__item gw__item--${i}" href="#/product/${p.handle}" data-handle="${p.handle}" aria-label="${p.title}"><img src="${posterURL(p)}" alt="${p.title}" draggable="false"></a>`).join('')}</div>
    <div class="gw__cta"><a class="btn-hero btn-hero--dark" href="#/collection"><span>Shop all ${PRODUCTS.length} posters</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>
  </div></section>

  <section class="statement"><div class="wrap">
    <p class="serif">Every car has a story. <em>Hang yours.</em></p>
    <span>${feature.fact || ''}</span>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Just in</div><h2 class="serif">New on <em>the wall</em></h2></div>
    <div class="hs">${fresh.map(card).join('')}</div>
  </div></section>

  <section class="section section--soft"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Find your fit</div><h2 class="serif">Pick your <em>size</em></h2><p>Three sizes, all made to fit standard frames.</p></div>
    <div class="sizeguide">${SIZES.map((s) => `<div class="sizeguide__item"><div class="sizeguide__box" style="--w:${s.w * 3.6}px;--h:${s.h * 3.6}px"><img src="${posterURL(feature)}" alt="" draggable="false"></div><b>${s.label.replace(/ cm.*/, '')} cm</b><small>${s.label.match(/\(([SML])\)/)[1]} · from ${money(salePrice(s.price))}</small></div>`).join('')}</div>
  </div></section>

  ${follow()}
  ${newsletter()}`;
}


// ---- Home C: story-led concept (Home A and B are kept as the other two designs) ----
function homeC() {
  const best = FEATURED.best.slice(0, 8).map(byHandle).filter(Boolean);
  const wall = wallPicks();
  const storyPoster = byHandle('porsche-917k') || PRODUCTS[0];
  return `
  ${hero('home')}

  <section class="story"><div class="wrap story__in">
    <div class="story__copy">
      <div class="eyebrow">Our story</div>
      <h2 class="serif">Named after <em>the pit wall.</em></h2>
      <p>In motorsport, the pit wall is where a race is really run: the crew watching the timing screens, calling the strategy and making the decisions that win.</p>
      <p>We named our shop after it because every car lover has a place where the obsession lives. Ours is a wall. Pitwall prints turns the cars you love into posters that belong there.</p>
      <a class="btn-hero btn-hero--dark" href="#/collection"><span>Meet the collection</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
    </div>
    <a class="room story__art" href="#/product/${storyPoster.handle}">${wallScene(ROOMS[1], storyPoster)}<span class="room__cap">${storyPoster.title}</span></a>
  </div></section>

  <section class="section"><div class="wrap">
    <ol class="steps">
      <li><span class="steps__n">01</span><h3>Cars first</h3><p>${PRODUCTS.length} designs across ${BRANDS.length} brands, from hypercars to Le Mans legends.</p></li>
      <li><span class="steps__n">02</span><h3>Printed to order</h3><p>Every poster is printed on canvas after you order, so each one is made fresh for you.</p></li>
      <li><span class="steps__n">03</span><h3>Made to hang</h3><p>Three sizes that fit standard frames, shipped free and dispatched within 2 days.</p></li>
    </ol>
  </div></section>

  <section class="gw"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Curated for you</div><h2 class="serif">Build a wall <em>worth stopping for</em></h2><p>Mix sizes, mix eras, and hang a few legends side by side.</p></div>
    <div class="gw__row">${wall.map((p, i) => `<a class="gw__item gw__item--${i}" href="#/product/${p.handle}" data-handle="${p.handle}" aria-label="${p.title}"><img src="${posterURL(p)}" alt="${p.title}" draggable="false"></a>`).join('')}</div>
    <div class="gw__cta"><a class="btn-hero btn-hero--dark" href="#/collection"><span>Shop all ${PRODUCTS.length} posters</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Bestsellers</div><h2 class="serif">Most loved <em>prints</em></h2></div>
    <div class="grid">${best.slice(0, 6).map(card).join('')}</div>
    <div style="text-align:center"><a class="btn-ghost btn-ghost--ink" href="#/collection">View all ${PRODUCTS.length} posters</a></div>
  </div></section>

  <section class="section section--soft findit"><div class="wrap">
    <div class="section__head"><div class="eyebrow">Can't find your car?</div><h2 class="serif">Search the <em>wall</em></h2><p>Look up a model, brand or racing series.</p></div>
    <button class="findit__bar" type="button" data-open-search aria-label="Search the collection">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>
      <span>Search a car model<span class="findit__eg"> (e.g. Porsche 911, Ferrari F40)</span></span>
    </button>
  </div></section>

  ${follow()}
  ${newsletter()}`;
}

function home(v) {
  // Home C is the main page. The earlier designs are still available at #/?v=a and #/?v=b.
  return v === 'a' ? homeA() : v === 'b' ? homeB() : homeC();
}

// "All posters" shows a random mix so no brand or category clumps together; one order per page load keeps paging stable.
const mixRank = {};
const shuffled = (list) => [...list].sort((a, b) => (mixRank[a.handle] ??= Math.random()) - (mixRank[b.handle] ??= Math.random()));

function collection() {
  let list = PRODUCTS.filter((p) => (!state.theme || p.theme === state.theme) && (!state.brand || p.brand === state.brand));
  if (state.sort === 'best' && !state.theme && !state.brand) list = shuffled(list);
  else if (state.sort === 'best') { const rank = (p) => { const i = FEATURED.best.indexOf(p.handle); return i < 0 ? 999 : i; }; list = [...list].sort((x, y) => rank(x) - rank(y)); }
  if (state.sort === 'az') list = [...list].sort((a, b) => a.title.localeCompare(b.title));
  if (state.sort === 'za') list = [...list].sort((a, b) => b.title.localeCompare(a.title));
  const pages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
  state.page = Math.min(state.page, pages);
  const shown = list.slice((state.page - 1) * PAGE_SIZE, state.page * PAGE_SIZE);
  return `
  ${hero()}
  <div class="wrap">
    <h1 class="page-title">${[state.brand, state.theme].filter(Boolean).join(' · ') || 'Automotive'}</h1>
    <div class="toolbar">
      <div class="chips">
        <button class="chip ${!state.theme ? 'is-on' : ''}" data-chip="">All</button>
        ${THEMES.map((t) => `<button class="chip ${state.theme === t ? 'is-on' : ''}" data-chip="${t}">${t}</button>`).join('')}
      </div>
      <label>Brand: <select id="brand" aria-label="Filter by brand">
        <option value="">All brands</option>
        ${BRANDS.map((b) => `<option value="${b}" ${state.brand === b ? 'selected' : ''}>${b}</option>`).join('')}</select></label>
      <label>Sort by: <select id="sort">
        <option value="best" ${state.sort === 'best' ? 'selected' : ''}>Best selling</option>
        <option value="az" ${state.sort === 'az' ? 'selected' : ''}>Title, A-Z</option>
        <option value="za" ${state.sort === 'za' ? 'selected' : ''}>Title, Z-A</option></select></label>
      <span class="count">${list.length} ${list.length === 1 ? 'product' : 'products'}</span>
    </div>
    ${shown.length ? `<div class="grid">${shown.map(card).join('')}</div>` : '<div class="empty-state"><h3>No prints match yet</h3><p>Try another brand or theme.</p></div>'}
    ${pages > 1 ? `<div class="pager">${Array.from({ length: pages }, (_, i) => `<button data-page="${i + 1}" class="${state.page === i + 1 ? 'is-on' : ''}">${i + 1}</button>`).join('')}</div>` : ''}
  </div>
  ${newsletter()}`;
}

// Room photos for the "on the wall" gallery views. cx/cy place the poster's centre (as % of the photo);
// pw is the poster's width as a % of the photo: fixed per room so it always looks right in the scene.
const ROOMS = [
  { id: 'a', src: window.PWA('rooms/room-a.jpg'), cx: 30, cy: 33, pw: 19, label: 'Bright living room' },
  { id: 'b', src: window.PWA('rooms/room-b.jpg'), cx: 50, cy: 25, pw: 25, label: 'Cosy lounge' },
];
const IC = {
  tag: '<svg viewBox="0 0 24 24"><path d="M3 12.5V4h8.5L21 13.5 13.5 21z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>',
  shield: '<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6z"/><path d="M8.8 12l2.4 2.4 4.2-4.6"/></svg>',
  truck: '<svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 9h4.5L21 12.5V16h-8"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
  returns: '<svg viewBox="0 0 24 24"><path d="M9 7H4v5"/><path d="M4.5 12A8 8 0 1 1 7 17.5"/></svg>',
  lock: '<svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
  paper: '<svg viewBox="0 0 24 24"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/></svg>',
  drop: '<svg viewBox="0 0 24 24"><path d="M12 3s6 6.2 6 10.5A6 6 0 0 1 6 13.5C6 9.2 12 3 12 3z"/></svg>',
  tube: '<svg viewBox="0 0 24 24"><rect x="3" y="9" width="18" height="6" rx="3"/><path d="M7 9v6M17 9v6"/></svg>',
  clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
  frame: '<svg viewBox="0 0 24 24"><rect x="4" y="3.5" width="16" height="17" rx="1"/><rect x="8" y="7.5" width="8" height="9"/></svg>',
  cube: '<svg viewBox="0 0 24 24"><path d="M12 2.8l8 4.4v9.6l-8 4.4-8-4.4V7.2z"/><path d="M4 7.2l8 4.4 8-4.4M12 11.6v9.6"/></svg>',
  heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-8-5-8-11a4.5 4.5 0 0 1 8-2.5A4.5 4.5 0 0 1 20 9c0 6-8 11-8 11z"/></svg>',
  zoom: '<svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.8-4.8M10.5 7.8v5.4M7.8 10.5h5.4"/></svg>',
  check: '<svg viewBox="0 0 24 24"><path d="M12 2l2.4 1.8 3-.2 1 2.8 2.5 1.7-.9 2.9.9 2.9-2.5 1.7-1 2.8-3-.2L12 22l-2.4-1.8-3 .2-1-2.8L3.1 16l.9-2.9L3.1 10.2l2.5-1.7 1-2.8 3 .2z"/><path d="M8.5 12.2l2.5 2.5 4.5-5" class="tick"/></svg>',
};

function wallScene(room, p) {
  return `<div class="wallscene" data-room="${room.id}" style="--room:url(${room.src});--cx:${room.cx}%;--cy:${room.cy}%;--pw:${(room.pw * Math.sqrt(p.ratio / (2 / 3))).toFixed(2)}%;--ar:${p.ratio}"><div class="wallscene__poster"><img src="${posterURL(p)}" alt="${p.title} on a wall" draggable="false"></div></div>`;
}

// Three quick stats under the size picker (whichever the car has), so the buy box is never padded with empty space.
// Delivery window under the button: dispatched within 2 days, delivered about 10-15 days after ordering (the supplier's estimate).
function deliveryRange() {
  const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const day = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
  return `${fmt(day(10))} – ${fmt(day(15))}`;
}

function highlightsHtml() {
  const items = [['paper', 'Canvas print', 'Made to order'], ['truck', 'Free shipping', 'Ships in 2 days'], ['shield', 'Delivery cover', 'Refund if lost or damaged']];
  return `<div class="hl">${items.map(([i, t, s]) => `<div>${IC[i]}<b>${t}</b><small>${s}</small></div>`).join('')}</div>`;
}

function specsHtml(p) {
  const rows = [
    ['Engine', p.engine], ['Transmission', p.trans], ['Power', p.hp && `${p.hp} hp`], ['Torque', p.tq && `${p.tq} lb-ft`],
    ['0–60 mph', p.zero60 && `${p.zero60} s`], ['Top speed', p.top && `${p.top} mph`], ['Weight', p.weight], ['Drivetrain', p.drive],
    ['Built', p.built && (p.built === 'Series' ? 'Series production' : `Limited to ${p.built}`)],
  ].filter(([, v]) => v);
  return rows.length ? `<dl class="specs">${rows.map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}</dl>` : '';
}

// Same brand first, then same theme, then the rest.
function related(p) {
  const score = (x) => (x.brand === p.brand ? 2 : 0) + (x.theme === p.theme ? 1 : 0);
  return PRODUCTS.filter((x) => x.handle !== p.handle).map((x, i) => [x, i]).sort((m, n) => score(n[0]) - score(m[0]) || m[1] - n[1]).slice(0, 3).map(([x]) => x);
}

function product(handle) {
  const p = PRODUCTS.find((x) => x.handle === handle);
  if (!p) return `<div class="wrap section"><h1 class="page-title">Poster not found</h1><a class="btn-ghost btn-ghost--ink" href="#/collection">Back to collection</a></div>`;
  const blurb = `This ${p.brand} ${p.model} poster is made to anchor a garage, study or living room, and pairs equally well with other prints in the collection.`;
  const infoMix = `
      <div class="info info--mix">
        <div class="info__group">
          ${SHOW_REVIEWS ? `<div class="rating rating--mix"><span class="stars5" style="--pct:${(4.7 / 5 * 100).toFixed(0)}%" aria-label="Rated 4.7 out of 5"></span></div>` : ''}
          <h1>${p.title}</h1>
          <div class="price price--lg" id="price"></div>
        </div>
        <div class="info__group">
          ${highlightsHtml()}
        </div>
        <div class="info__group">
          <div class="min-label">Size</div>
          <div class="opts" id="sizes">${SIZES.map((s, i) => `<button class="opt ${i === 1 ? 'is-on' : ''}" data-size="${s.id}">${s.label}</button>`).join('')}</div>
          <button class="btn btn--std" id="add">ADD TO CART</button>
          <div class="delivery">${IC.truck}<span>Order today, delivered by <b>${deliveryRange()}</b></span></div>
        </div>
        <div class="info__group info__end">
          <div class="bundle-strip"><div><b>Choose your print</b><small>Pick your favorite</small></div><div><b>Buy 2 prints</b><small>Get 15% OFF</small></div><div><b>Buy 3+ prints</b><small>Get 25% OFF</small></div></div>
          <div class="ship-strip"><span>${IC.truck}Free shipping</span><span class="tick-sep">✦</span><span>${IC.returns}Refund if lost or damaged</span></div>
        </div>
      </div>
  `;
  return `
  <div class="wrap">
    <div class="crumbs"><a href="#/">Home</a> / <a href="#/collection">Automotive</a> / ${p.title}</div>
    <div class="pdp pdp--mix">
      <div class="gallery" id="gallery">
        <div class="stage" id="stage">
          <div class="stage__size" id="sizeTag"></div>
          <div class="stage__btns">
            <button class="round-btn" id="wishBtn" aria-label="Save to wishlist">${IC.heart}</button>
            <button class="round-btn" id="zoomBtn" aria-label="Zoom" hidden>${IC.zoom}</button>
          </div>
          <div class="pane viewer" id="viewer" data-pane="3d">
            <div class="viewer__hint" id="hint">Drag sideways to spin · Scroll to zoom</div>
            <div class="viewer__tools">
              <button class="tool" data-tool="reset">Reset view</button>
            </div>
          </div>
          ${ROOMS.map((r) => `<div class="pane" data-pane="wall-${r.id}" hidden>${wallScene(r, p)}</div>`).join('')}
          <div class="pane shot--framed" data-pane="framed" hidden>
            <div class="shot__frame" id="framedPoster"><img src="${posterURL(p)}" alt="${p.title} framed" draggable="false"></div>
          </div>
        </div>
        <div class="thumbs" id="thumbs">
          <button class="thumb is-on" data-view="3d" aria-label="3D view"><span class="thumb__3d"><img src="${posterURL(p)}" alt="" draggable="false" style="aspect-ratio:${p.ratio}"><i>${IC.cube}</i></span></button>
          <button class="thumb" data-view="framed" aria-label="Framed, straight on"><span class="thumb__framed"><span class="thumb__fp" style="aspect-ratio:${p.ratio}"><img src="${posterURL(p)}" alt="" draggable="false"></span></span></button>
          ${ROOMS.map((r) => `<button class="thumb" data-view="wall-${r.id}" aria-label="${r.label}">${wallScene(r, p)}</button>`).join('')}
        </div>
      </div>
      ${infoMix}
    </div>
    <div class="details">
      <div class="panel desc">
        <div class="eyebrow">${[p.variant, p.years].filter(Boolean).join(' · ')}</div>
        <h3>${p.brand} ${p.model}</h3>
        <p>${p.fact || blurb}</p>
        ${specsHtml(p)}
      </div>
      <div class="panel"><div class="acc">${FAQ.map(([q, a], i) => `<details ${i === 0 ? 'open' : ''}><summary>${q}</summary><p>${a}</p></details>`).join('')}</div></div>
    </div>
  </div>
  <section class="section section--soft"><div class="wrap"><div class="section__head"><div class="eyebrow">Made for your walls</div><h2>Made to last, shipped with care</h2></div>${usp()}</div></section>
  <div class="wrap section"><div class="section__head"><h2>You may also like</h2></div>
    <div class="grid">${related(p).map(card).join('')}</div></div>
  ${newsletter()}`;
}

/* ---------- product interactions ---------- */
async function mountProduct(handle) {
  const p = PRODUCTS.find((x) => x.handle === handle);
  if (!p) return;
  let size = SIZES[1];
  let framed = false;
  const priceEl = $('#price');
  const sizeTag = $('#sizeTag');
  const framedPoster = $('#framedPoster');
  // The 3D and straight-on views reflect the chosen size. The wall photos keep one fixed poster size that suits each scene.
  const applySize = () => {
    sizeTag.textContent = size.label;
    framedPoster.style.height = `${52 + 30 * (size.h - 40) / 30}%`;
    framedPoster.style.aspectRatio = `${p.ratio}`;
    framedPoster.classList.toggle('is-framed', framed);
    viewer?.setSize(size);
    viewer?.setFramed(framed);
  };
  const showPrice = () => {
    const now = framed ? size.framed : salePrice(size.price);
    priceEl.innerHTML = `<s>${money(now / WAS_RATE)}</s><b>${money(now)}</b><span class="badge">Sale</span>`;
    applySize();
  };
  showPrice();

  $('#sizes').addEventListener('click', (e) => {
    const b = e.target.closest('[data-size]');
    if (!b) return;
    size = SIZES.find((s) => s.id === b.dataset.size);
    document.querySelectorAll('#sizes .opt').forEach((o) => o.classList.toggle('is-on', o === b));
    showPrice();
  });
  $('#finish')?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-f]');
    if (!b) return;
    framed = b.dataset.f === '1';
    document.querySelectorAll('#finish .fin').forEach((o) => o.classList.toggle('is-on', o === b));
    showPrice();
  });
  $('#add').addEventListener('click', () => { addToCart(p, size, framed); });

  // Gallery: big preview on top, four views below (3D, framed straight-on, two room photos).
  let view = '3d';
  const showView = (v) => {
    view = v;
    document.querySelectorAll('#thumbs .thumb').forEach((x) => x.classList.toggle('is-on', x.dataset.view === v));
    document.querySelectorAll('#stage [data-pane]').forEach((pane) => { pane.hidden = pane.dataset.pane !== v; });
    $('#zoomBtn').hidden = v === '3d';
  };
  $('#thumbs').addEventListener('click', (e) => { const t = e.target.closest('[data-view]'); if (t) showView(t.dataset.view); });

  const wb = $('#wishBtn');
  wb.dataset.wish = handle;
  wb.classList.toggle('is-on', wishHas(handle));
  wb.setAttribute('aria-pressed', String(wishHas(handle)));

  // Zoom: show the current image view large in a lightbox. Preview resolution only; saving is deterred, not blocked outright.
  $('#zoomBtn').addEventListener('click', () => {
    const pane = document.querySelector(`#stage [data-pane="${view}"]`);
    if (!pane) return;
    const box = document.createElement('div');
    box.className = 'lightbox';
    box.innerHTML = `<div class="lightbox__stage">${pane.innerHTML}</div><button class="lightbox__x" aria-label="Close">✕</button>`;
    const close = () => { box.remove(); document.removeEventListener('keydown', onKey); };
    const onKey = (ev) => { if (ev.key === 'Escape') close(); };
    box.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
  });
  $('#stage').addEventListener('contextmenu', (e) => { if (!e.target.closest('.viewer')) e.preventDefault(); });

  $('.viewer__tools').addEventListener('click', (e) => {
    const t = e.target.closest('[data-tool]');
    if (!t || !viewer) return;
    const k = t.dataset.tool;
    if (k === 'reset') viewer.reset();
  });
  $('#viewer').addEventListener('pointerdown', () => $('#hint').classList.add('is-gone'), { once: true });

  try {
    const { createViewer } = await import('./viewer.js?v=25');
    if (location.hash.split('?')[0] !== `#/product/${handle}`) return;
    viewer = createViewer($('#viewer'), p, size);
    viewer.setFramed(framed);
  } catch (err) {
    console.error(err);
    $('#viewer').insertAdjacentHTML('afterbegin', `<img src="${posterURL(p)}" alt="${p.title}" style="height:100%;margin:auto;padding:24px">`);
  }
}

/* ---------- cart ---------- */
const drawer = $('#drawer');
const scrim = $('#scrim');

function discount() { const n = cart.reduce((a, l) => a + l.qty, 0); return n >= 3 ? 0.25 : n === 2 ? 0.15 : 0; }

function renderCart() {
  const n = cart.reduce((a, l) => a + l.qty, 0);
  const cc = $('#cartCount');
  cc.hidden = !n; cc.textContent = n;
  saveCart();
  const sub = cart.reduce((a, l) => a + unit(l) * l.qty, 0);
  const d = discount();
  drawer.innerHTML = `
    <div class="drawer__head"><h3>Your cart</h3><button class="icon-btn" id="closeCart" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>
    <div class="drawer__body">${cart.length ? cart.map((l, i) => `
      <div class="line"><img src="${l.custom ? l.custom.src : posterURL(l.p)}" alt="">
        <div><h4>${l.p.title}</h4><small>${lineLabel(l)}</small><small>${money(unit(l))}</small>
          <div class="qty"><button data-q="${i}" data-d="-1" aria-label="Less">–</button><span>${l.qty}</span><button data-q="${i}" data-d="1" aria-label="More">+</button></div></div>
        <button class="line__rm" data-rm="${i}">Remove</button></div>`).join('') : `<div class="empty"><p>Your cart is empty.</p><br><a class="btn-ghost btn-ghost--ink" href="#/collection" id="shopOn">Shop posters</a></div>`}</div>
    ${cart.length ? `<div class="drawer__foot">
      ${d ? `<div class="row"><span>Bundle discount (${d * 100}%)</span><span>–${money(sub * d)}</span></div>` : ''}
      <div class="row"><strong>Total</strong><strong>${money(sub * (1 - d))}</strong></div>
      <div class="ship-note">Free shipping on every order.</div>
      <button class="btn" data-checkout>CHECKOUT</button></div>` : ''}`;
}

function openCart(on = true) {
  drawer.classList.toggle('is-on', on);
  scrim.classList.toggle('is-on', on);
  drawer.setAttribute('aria-hidden', String(!on));
  document.body.style.overflow = on ? 'hidden' : '';
}

function addToCart(p, size, framed = false) {
  const found = cart.find((l) => !l.custom && l.p === p && l.size === size && !!l.framed === framed);
  if (found) found.qty++; else cart.push({ p, size, qty: 1, framed });
  renderCart(); openCart(true);
}

drawer.addEventListener('click', (e) => {
  if (e.target.closest('#closeCart') || e.target.closest('#shopOn')) openCart(false);
  if (e.target.closest('[data-checkout]')) { shopifyCheckout(); }
  const q = e.target.closest('[data-q]');
  if (q) { const l = cart[+q.dataset.q]; l.qty += +q.dataset.d; if (l.qty < 1) cart.splice(+q.dataset.q, 1); renderCart(); }
  const rm = e.target.closest('[data-rm]');
  if (rm) { cart.splice(+rm.dataset.rm, 1); renderCart(); }
});
scrim.addEventListener('click', () => openCart(false));

// Shopify's bot check only runs when a visitor types into the real form, so the real signup form
// is moved into whichever placeholder (footer band or popup) is on screen.
const NLF = document.getElementById('pw-nl');
window.__adoptNL = (ph, source) => {
  if (!NLF || NLF.closest('.signup-pop')) return;
  const pb = ph.querySelector('button'), pi = ph.querySelector('input');
  const b = NLF.querySelector('button'), i = NLF.querySelector('input[type=email]');
  NLF.className = ph.className;
  b.className = pb.className; b.textContent = pb.textContent; b.disabled = false;
  i.placeholder = pi.placeholder; i.value = '';
  NLF.querySelector('[name="contact[tags]"]').value = `newsletter, ${source}`;
  NLF.querySelector('[name=return_to]').value = `/?pw_joined=${source}`;
  ph.replaceWith(NLF);
};
if (NLF) NLF.addEventListener('submit', () => {
  const b = NLF.querySelector('button');
  setTimeout(() => { b.disabled = true; b.dataset.t = b.textContent; b.textContent = 'Sending...'; }, 0);
  setTimeout(() => { if (b.disabled) { b.disabled = false; b.textContent = b.dataset.t; window.__toast('That did not go through. Please try again.'); } }, 15000);
});
new MutationObserver(() => {
  const ph = document.querySelector('#app .newsletter form:not(#pw-nl)');
  if (ph) window.__adoptNL(ph, 'footer');
}).observe(document.getElementById('app'), { childList: true, subtree: true });
(() => {
  if (new URLSearchParams(location.search).get('pw_contact')) {
    history.replaceState(null, '', location.pathname + '#/help/contact');
    setTimeout(() => { const f = document.getElementById('pw-contact'), ok = document.getElementById('contactOk'); if (f && ok) { f.hidden = true; ok.hidden = false; } window.__toast('Message sent. We will reply by email.'); }, 1200);
    return;
  }
  const j = new URLSearchParams(location.search).get('pw_joined');
  if (!j) return;
  try { localStorage.setItem('pw-signup', JSON.stringify({ joined: true })); } catch (e) { /* storage blocked */ }
  history.replaceState(null, '', location.pathname);
  setTimeout(() => window.__toast(j === 'popup' ? 'Welcome! Your code PITWALL10 is ready to use at checkout.' : 'Thanks, you are on the list.'), 900);
})();

// Hands the cart to Shopify's real checkout.
async function shopifyCheckout() {
  const items = cart.filter((l) => !l.custom && !l.framed).map((l) => ({ id: l.p.variants?.[l.size.label]?.id, quantity: l.qty })).filter((i) => i.id);
  if (!items.length) { window.__toast('Those posters are not available to order yet.'); return; }
  try {
    await fetch('/cart/clear.js', { method: 'POST' });
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) throw new Error('add failed');
    location.href = '/checkout';
  } catch (err) { window.__toast('Sorry, checkout could not start. Please try again.'); }
}
$('#cartBtn').addEventListener('click', () => openCart(true));
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') openCart(false); });

let toastT;
window.__toast = (msg) => { const t = $('#toast'); t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2400); };

/* ---------- Best Sellers, New In, Brands ---------- */
const arrow = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

function listPage({ eyebrow, title, lede, list, note }) {
  return `
  ${hero('page', { eyebrow, title, lede })}
  <div class="wrap">
    <div class="listhead"><span class="count">${list.length} prints</span>${note ? `<span class="listhead__note">${note}</span>` : ''}</div>
    <div class="grid">${list.map(card).join('')}</div>
    <div class="pagecta"><a class="btn-solid" href="#/collection"><span>Browse all ${PRODUCTS.length} posters</span>${arrow}</a></div>
  </div>
  ${newsletter()}`;
}

const bestsellers = () => listPage({
  eyebrow: 'Most loved', title: 'Best <em>sellers.</em>', lede: 'The prints we would hang first.',
  list: FEATURED.best.map(byHandle).filter(Boolean),
});

const newIn = () => listPage({
  eyebrow: 'Just added', title: 'New <em>in.</em>', lede: 'The latest cars to join the wall.',
  list: PRODUCTS.slice(-12).reverse(),
});

function brandsPage() {
  const tiles = BRANDS.map((b) => {
    const ps = PRODUCTS.filter((p) => p.brand === b);
    const lead = ps[0];
    return `<a class="card" href="#/collection?brand=${encodeURIComponent(b)}">
      <div class="card__media"><div class="card__frame" style="--r:${lead.ratio}"><img src="${posterURL(lead)}" alt="${b} poster" loading="lazy"></div></div>
      <h3 class="card__title">${b}</h3>
      <div class="price"><span>${ps.length} ${ps.length === 1 ? 'poster' : 'posters'}</span></div>
    </a>`;
  }).join('');
  return `
  ${hero('page', { eyebrow: 'Shop by marque', title: 'Every <em>brand.</em>', lede: `${BRANDS.length} manufacturers, from Maranello to Molsheim.` })}
  <div class="wrap">
    <div class="listhead"><span class="count">${BRANDS.length} brands</span></div>
    <div class="grid grid--4">${tiles}</div>
  </div>
  ${newsletter()}`;
}

/* ---------- About us ---------- */
function aboutPage() {
  const spot = byHandle(FEATURED.spotlight) || PRODUCTS[0];
  return `
  ${hero('page', { eyebrow: 'About us', title: 'Built for <em>car people.</em>', lede: 'A poster shop run by people who still look up when something loud goes past.' })}

  <section class="about-story"><div class="wrap about-story__in">
    <div class="about-story__copy">
      <div class="eyebrow">Our story</div>
      <h2 class="serif">Named after <em>the pit wall.</em></h2>
      <p>In motorsport, the pit wall is where a race is really run: the crew watching the timing screens, calling the strategy and making the decisions that win.</p>
      <p>We named our shop after it because every car lover has a place where the obsession lives. Ours is a wall. Pitwall Prints turns the cars you love into posters that belong there.</p>
      <img class="about-sig" src="${window.PWA('brand/pitwall-signature.png')}" alt="Pitwall" width="700" height="230">
    </div>
    <a class="about-story__art" href="#/product/${spot.handle}" aria-label="${spot.title}">
      <div class="card__frame" style="--r:${spot.ratio}"><img src="${posterURL(spot)}" alt="${spot.title} poster"></div>
    </a>
  </div></section>

  <section class="section section--soft"><div class="wrap">
    <div class="section__head"><div class="eyebrow">What we care about</div><h2 class="serif">Three simple <em>promises</em></h2></div>
    <ol class="steps">
      <li><span class="steps__n">01</span><h3>Cars first</h3><p>${PRODUCTS.length} designs across ${BRANDS.length} brands, from hypercars to Le Mans legends. Every one is about the car.</p></li>
      <li><span class="steps__n">02</span><h3>Printed to order</h3><p>Nothing sits in a warehouse. Each poster is printed on canvas after you order, so yours is made fresh.</p></li>
      <li><span class="steps__n">03</span><h3>Made to hang</h3><p>Three sizes that fit standard frames, shipped free and dispatched within 2 days.</p></li>
    </ol>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="about-stats">
      <div><b>${PRODUCTS.length}</b><span>Posters</span></div>
      <div><b>${BRANDS.length}</b><span>Brands</span></div>
      <div><b>${SIZES.length}</b><span>Sizes</span></div>
      <div><b>Free</b><span>Shipping</span></div>
    </div>
    <div class="pagecta"><a class="btn-solid" href="#/collection"><span>Meet the collection</span>${arrow}</a></div>
  </div></section>
  ${newsletter()}`;
}

/* ---------- Help ---------- */
const INCH = (cm) => (cm / 2.54).toFixed(1);

function helpPage() {
  const nav = [['shipping', 'Shipping'], ['returns', 'Returns'], ['size-guide', 'Size guide'], ['faq', 'FAQ'], ['contact', 'Contact']];
  const maxH = Math.max(...SIZES.map((s) => s.h));
  const spot = byHandle(FEATURED.spotlight) || PRODUCTS[0];
  return `
  ${hero('page', { eyebrow: 'Help center', title: 'How can we <em>help?</em>', lede: 'Shipping, sizing, returns and answers to the questions we get most.' })}
  <div class="wrap help">
    <aside class="help__nav" aria-label="Help topics">${nav.map(([id, t]) => `<a href="#/help/${id}" data-help="${id}">${t}</a>`).join('')}</aside>
    <div class="help__body">

      <section id="help-shipping" class="help__sec">
        <h2 class="serif">Shipping &amp; <em>delivery</em></h2>
        <div class="facts">
          <div><b>Free</b><span>Shipping on every order</span></div>
          <div><b>2 days</b><span>To print and dispatch</span></div>
          <div><b>10-15 days</b><span>Typical delivery time</span></div>
        </div>
        <p>Every poster is printed to order, so it is made after you place your order. We dispatch within 2 days and delivery usually takes around 10-15 days from your order date. Shipping is free, whatever you buy.</p>
        <p>You will see an estimated delivery window on every product page and in your cart.</p>
      </section>

      <section id="help-returns" class="help__sec">
        <h2 class="serif">Returns &amp; <em>refunds</em></h2>
        <p>If your order is lost, arrives damaged, or does not arrive within 30 days, we will refund it. Get in touch using the form below and include your order details and, for damage, a photo.</p>
        <p>Because each poster is printed to order, please check the size guide before you buy.</p>
      </section>

      <section id="help-size-guide" class="help__sec">
        <h2 class="serif">Size <em>guide</em></h2>
        <p>Three sizes, all made to fit standard off-the-shelf frames. Posters are sold unframed.</p>
        <div class="sizes">${SIZES.map((s) => {
          const l = s.label.match(/\(([SML])\)/)[1];
          return `<div class="sizes__item"><div class="sizes__box" style="--h:${s.h / maxH};--w:${s.w / maxH}"><img src="${posterURL(spot)}" alt="" draggable="false"></div><b>${l}</b><span>${s.w} x ${s.h} cm</span><small>${INCH(s.w)} x ${INCH(s.h)} in</small></div>`;
        }).join('')}</div>
        <div class="table-wrap"><table class="sizes__table">
          <thead><tr><th>Size</th><th>Centimeters</th><th>Inches</th><th>From</th></tr></thead>
          <tbody>${SIZES.map((s) => `<tr><td>${s.label.match(/\(([SML])\)/)[1]}</td><td>${s.w} x ${s.h} cm</td><td>${INCH(s.w)} x ${INCH(s.h)} in</td><td>${money(salePrice(s.price))}</td></tr>`).join('')}</tbody>
        </table></div>
      </section>

      <section id="help-faq" class="help__sec">
        <h2 class="serif">Common <em>questions</em></h2>
        <div class="faq">${FAQ.map(([q, a], i) => `<details ${i === 0 ? 'open' : ''}><summary>${q}</summary><p>${a}</p></details>`).join('')}</div>
      </section>

      <section id="help-contact" class="help__sec">
        <h2 class="serif">Get in <em>touch</em></h2>
        <p>Questions about an order, a size, or a poster you cannot find? Send us a message and we will reply by email. You can also write to <a href="mailto:bristovabrush@gmail.com">bristovabrush@gmail.com</a>.</p>
        <form class="contact" id="contactForm">
          <label>Name<input name="name" required autocomplete="name"></label>
          <label>Email<input name="email" type="email" required autocomplete="email"></label>
          <label class="contact__wide">Message<textarea name="msg" rows="5" required></textarea></label>
          <button class="btn-solid contact__wide" type="submit"><span>Send message</span>${arrow}</button>
        </form>
        <div class="contact__ok" id="contactOk" hidden><h3 class="serif">Thank you.</h3><p>Your message is on its way. We will reply by email.</p></div>
      </section>
    </div>
  </div>
  ${newsletter()}`;
}

function mountHelp(section) {
  const form = $('#contactForm');
  const nf = document.getElementById('pw-contact');
  if (form && nf) {
    form.replaceWith(nf);
    nf.addEventListener('submit', () => { const b = nf.querySelector('button[type=submit]'); setTimeout(() => { b.disabled = true; b.querySelector('span').textContent = 'Sending...'; }, 0); });
  }
  const links = document.querySelectorAll('[data-help]');
  const mark = (id) => links.forEach((a) => a.classList.toggle('is-on', a.dataset.help === id));
  mark(section || 'shipping');
  if (section) {
    const el = document.getElementById(`help-${section}`);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: 'instant', block: 'start' }), 30);
  }
  const secs = [...document.querySelectorAll('.help__sec')];
  const io = new IntersectionObserver((ents) => {
    const vis = ents.filter((x) => x.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
    if (vis) mark(vis.target.id.replace('help-', ''));
  }, { rootMargin: '-120px 0px -60% 0px' });
  secs.forEach((s) => io.observe(s));
}

/* ---------- Custom poster ---------- */
const CU_TOL = 0.03;          // how far from the exact shape an upload may be
const CU_RATIO = { p: ['3:4', '4:5', '5:7'], l: ['4:3', '5:4', '7:5'] };
const cuState = { s: 1, o: 'p', f: 0, orig: null, cur: null, own: false };
const cuSizeTxt = (z) => (cuState.o === 'p' ? `${z.w}x${z.h}` : `${z.h}x${z.w}`);
const cuTarget = (z) => (cuState.o === 'p' ? z.w / z.h : z.h / z.w);
const cuFits = (z) => cuState.cur && Math.abs((cuState.cur.w / cuState.cur.h) / cuTarget(z) - 1) <= CU_TOL;
const cuPrice = () => { const z = SIZES[cuState.s]; return cuState.f ? z.customFramed : z.custom; };

function customPage() {
  return `
  ${hero('page', { eyebrow: 'Custom poster', title: 'Your car, <em>your wall.</em>', lede: `Send us your PNG and we print it on canvas. From ${money(SIZES[0].custom)}.` })}
  <div class="wrap cu">
    <ol class="cu-steps">
      <li><span>01</span><b>Upload your PNG</b><small>Your own photo or design, high resolution.</small></li>
      <li><span>02</span><b>Pick size and finish</b><small>Canvas only, or with a black floating frame.</small></li>
      <li><span>03</span><b>We check it</b><small>We review the file before it is printed.</small></li>
      <li><span>04</span><b>Delivered to you</b><small>Printed to order, with free shipping.</small></li>
    </ol>
    <div class="cu-build">
      <label class="cu-drop" id="cuDrop" for="cuFile">
        <div id="cuDropIn"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5M4 20h16"/></svg><h3 class="serif">Upload your PNG</h3><p>Click to choose a file.<br>PNG, in the shape of your chosen size.</p></div>
        <input id="cuFile" type="file" accept="image/png" hidden>
      </label>
      <div>
        <div class="min-label">Size</div>
        <div class="opts" id="cuSizes">${SIZES.map((s, i) => `<button class="opt ${i === 1 ? 'is-on' : ''}" data-s="${i}"></button>`).join('')}</div>
        <div class="min-label cu-gap">Orientation</div>
        <div class="opts opts--2" id="cuOri"><button class="opt is-on" data-o="p">Portrait</button><button class="opt" data-o="l">Landscape</button></div>
        <div class="min-label cu-gap">Finish</div>
        <div class="fins" id="cuFin"><button class="fin is-on" data-f="0"><b>Canvas only</b><small>Ready to hang, or frame it yourself.</small></button><button class="fin" data-f="1"><b>Framed canvas</b><small>Black floating frame, no glass.</small></button></div>
        <div class="cu-shape" id="cuShape"></div>
        <div class="cu-q" id="cuQ" role="status"></div>
        <label class="cu-chk"><input type="checkbox" id="cuOwn"><span>I confirm I own this image or have permission to print it.</span></label>
        <div class="cu-price"><span id="cuDesc"></span><b id="cuPrice"></b></div>
        <button class="btn btn--std" id="cuAdd" disabled>Upload a PNG to continue</button>
        <p class="cu-note">Custom posters are kept in your cart only until you leave or reload this page.</p>
      </div>
    </div>
  </div>
  <div class="cropper" id="cuCrop" role="dialog" aria-modal="true" aria-label="Crop your image"><div class="cropper__box">
    <h3 class="serif">Crop your image</h3><p id="cuCropInfo"></p>
    <div class="cropper__view" id="cuCropView"><img id="cuCropImg" alt="" draggable="false"></div>
    <label class="cropper__zoom">Zoom <input type="range" id="cuZoom" min="0" max="1" step="0.01" value="0"></label>
    <div class="cropper__btns"><button class="btn-ghost btn-ghost--ink" id="cuCropCancel" type="button">Cancel</button><button class="btn-solid" id="cuCropApply" type="button"><span>Apply crop</span></button></div>
  </div></div>
  ${newsletter()}`;
}

function mountCustom() {
  Object.assign(cuState, { s: 1, o: 'p', f: 0, orig: null, cur: null, own: false });
  const cr = { scale: 1, min: 1, x: 0, y: 0, vw: 0, vh: 0 };

  const setImage = (src, w, h, isOrig) => {
    cuState.cur = { src, w, h };
    if (isOrig) { cuState.orig = { src, w, h }; cuState.o = w / h > 1 + CU_TOL ? 'l' : 'p'; }
    $('#cuDrop').classList.add('has');
    $('#cuDropIn').innerHTML = `<div class="cu-art" id="cuArt"><div class="cu-art__gap"><img src="${src}" alt="Your uploaded image"></div></div>`;
    update();
  };

  function update() {
    const z = SIZES[cuState.s];
    const o = cuState.o;
    document.querySelectorAll('#cuSizes .opt').forEach((b, i) => { b.textContent = `${cuSizeTxt(SIZES[i])} cm (${'SML'[i]})`; b.classList.toggle('is-on', i === cuState.s); });
    document.querySelectorAll('#cuOri .opt').forEach((b) => b.classList.toggle('is-on', b.dataset.o === o));
    document.querySelectorAll('#cuFin .fin').forEach((b, i) => b.classList.toggle('is-on', i === cuState.f));
    $('#cuPrice').textContent = money(cuPrice());
    $('#cuDesc').textContent = `${cuSizeTxt(z)} cm · ${o === 'p' ? 'portrait' : 'landscape'} · ${cuState.f ? 'framed canvas' : 'canvas only'}`;
    const longPx = Math.round(z.h / 2.54 * 150);
    const shortPx = Math.round(longPx * z.w / z.h);
    $('#cuShape').innerHTML = `Needs a <b>${o === 'p' ? 'portrait' : 'landscape'} ${CU_RATIO[o][cuState.s]}</b> image for ${cuSizeTxt(z)} cm, for example <b>${o === 'p' ? `${shortPx} x ${longPx}` : `${longPx} x ${shortPx}`} px</b> or larger.`;

    const q = $('#cuQ');
    let ok = false;
    const img = cuState.cur;
    if (!img) { q.className = 'cu-q'; q.textContent = ''; }
    else if (!cuFits(z)) {
      const other = SIZES.findIndex((s) => cuFits(s));
      const r = img.w / img.h;
      const shape = Math.abs(r - 1) <= CU_TOL ? 'square' : r > 1 ? 'landscape' : 'portrait';
      q.className = 'cu-q cu-q--bad';
      q.innerHTML = `This image is ${shape} (${img.w} x ${img.h} px), which does not match ${cuSizeTxt(z)} cm.${other >= 0 ? ` It is the right shape for <b>${cuSizeTxt(SIZES[other])} cm</b>. <button class="cu-btn" data-swap="${other}">Switch size</button>` : ''} <button class="cu-btn cu-btn--main" data-crop>Crop to fit</button>`;
    } else {
      ok = true;
      const have = Math.max(img.w, img.h);
      const dpi = Math.round(have / (z.h / 2.54));
      q.className = `cu-q ${have >= longPx ? 'cu-q--ok' : 'cu-q--warn'}`;
      q.textContent = have >= longPx
        ? `Right shape, and sharp at ${cuSizeTxt(z)} cm (${img.w} x ${img.h} px, about ${dpi} dpi).`
        : `Right shape, but only about ${dpi} dpi at this size (${img.w} x ${img.h} px). It may print soft. A larger file or a smaller size will look better.`;
      if (cuState.orig && img.src !== cuState.orig.src) q.innerHTML += ' <button class="cu-btn" data-crop>Adjust crop</button>';
    }
    const add = $('#cuAdd');
    add.disabled = !(ok && cuState.own);
    add.textContent = !img ? 'Upload a PNG to continue' : !ok ? 'Fix the image shape to continue' : !cuState.own ? 'Confirm the image rights to continue' : `ADD TO CART · ${money(cuPrice())}`;
    const art = $('#cuArt');
    if (art) art.className = `cu-art${cuState.f ? ' is-framed' : ''}${o === 'l' ? ' is-land' : ''}${img && !ok ? ' is-wrong' : ''}`;
  }

  $('#cuSizes').addEventListener('click', (e) => { const b = e.target.closest('[data-s]'); if (b) { cuState.s = +b.dataset.s; update(); } });
  $('#cuOri').addEventListener('click', (e) => { const b = e.target.closest('[data-o]'); if (b) { cuState.o = b.dataset.o; update(); } });
  $('#cuFin').addEventListener('click', (e) => { const b = e.target.closest('[data-f]'); if (b) { cuState.f = +b.dataset.f; update(); } });
  $('#cuQ').addEventListener('click', (e) => {
    const sw = e.target.closest('[data-swap]');
    if (sw) { cuState.s = +sw.dataset.swap; update(); }
    if (e.target.closest('[data-crop]')) openCrop();
  });
  $('#cuOwn').addEventListener('change', (e) => { cuState.own = e.target.checked; update(); });

  $('#cuFile').addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const q = $('#cuQ');
    if (file.type !== 'image/png') { cuState.cur = null; q.className = 'cu-q cu-q--bad'; q.textContent = 'Please upload a PNG file.'; return; }
    const reader = new FileReader();
    reader.onload = () => { const im = new Image(); im.onload = () => setImage(reader.result, im.naturalWidth, im.naturalHeight, true); im.src = reader.result; };
    reader.readAsDataURL(file);
  });

  $('#cuAdd').addEventListener('click', () => {
    const z = SIZES[cuState.s];
    cart.push({ p: { handle: 'custom', title: 'CUSTOM POSTER', ratio: cuState.cur.w / cuState.cur.h }, size: z, framed: !!cuState.f, qty: 1, custom: { src: cuState.cur.src, orient: cuState.o } });
    renderCart(); openCart(true);
  });

  /* Crop tool: a fixed-shape window over the image. Drag to move, slider or wheel to zoom. */
  const view = $('#cuCropView');
  const imgEl = $('#cuCropImg');
  const clamp = () => {
    const o = cuState.orig;
    cr.x = Math.min(0, Math.max(cr.vw - o.w * cr.scale, cr.x));
    cr.y = Math.min(0, Math.max(cr.vh - o.h * cr.scale, cr.y));
  };
  const draw = () => {
    const o = cuState.orig;
    imgEl.style.width = `${o.w * cr.scale}px`; imgEl.style.height = `${o.h * cr.scale}px`;
    imgEl.style.transform = `translate(${cr.x}px, ${cr.y}px)`;
  };
  function openCrop() {
    const o = cuState.orig;
    if (!o) return;
    const z = SIZES[cuState.s];
    const r = cuTarget(z);
    const maxW = Math.min(560, innerWidth - 80), maxH = Math.min(460, innerHeight - 260);
    let vw = maxW, vh = vw / r;
    if (vh > maxH) { vh = maxH; vw = vh * r; }
    cr.vw = Math.round(vw); cr.vh = Math.round(vh);
    view.style.width = `${cr.vw}px`; view.style.height = `${cr.vh}px`;
    imgEl.src = o.src;
    cr.min = Math.max(cr.vw / o.w, cr.vh / o.h); cr.scale = cr.min;
    cr.x = (cr.vw - o.w * cr.scale) / 2; cr.y = (cr.vh - o.h * cr.scale) / 2;
    $('#cuZoom').value = 0; clamp(); draw();
    $('#cuCropInfo').textContent = `Cropping to ${cuState.o === 'p' ? 'portrait' : 'landscape'} ${CU_RATIO[cuState.o][cuState.s]} for ${cuSizeTxt(z)} cm. Drag to move, use the slider to zoom.`;
    $('#cuCrop').classList.add('is-on');
    $('#cuCropApply').focus();
  }
  const zoomTo = (v) => {
    const cx = cr.vw / 2, cy = cr.vh / 2, old = cr.scale;
    cr.scale = cr.min * (1 + v * 3);
    const k = cr.scale / old;
    cr.x = cx - (cx - cr.x) * k; cr.y = cy - (cy - cr.y) * k;
    clamp(); draw(); $('#cuZoom').value = v;
  };
  $('#cuZoom').addEventListener('input', (e) => zoomTo(+e.target.value));
  view.addEventListener('wheel', (e) => { e.preventDefault(); zoomTo(Math.min(1, Math.max(0, +$('#cuZoom').value - e.deltaY / 1500))); }, { passive: false });
  let drag = null;
  view.addEventListener('pointerdown', (e) => { drag = { x: e.clientX - cr.x, y: e.clientY - cr.y }; view.setPointerCapture?.(e.pointerId); });
  view.addEventListener('pointermove', (e) => { if (!drag) return; cr.x = e.clientX - drag.x; cr.y = e.clientY - drag.y; clamp(); draw(); });
  view.addEventListener('pointerup', () => { drag = null; });
  const closeCrop = () => $('#cuCrop').classList.remove('is-on');
  $('#cuCropCancel').addEventListener('click', closeCrop);
  $('#cuCrop').addEventListener('click', (e) => { if (e.target.id === 'cuCrop') closeCrop(); });
  document.addEventListener('keydown', function esc(e) {
    if (!$('#cuCrop')) { document.removeEventListener('keydown', esc); return; }
    if (e.key === 'Escape') closeCrop();
  });
  $('#cuCropApply').addEventListener('click', () => {
    const sw = cr.vw / cr.scale, sh = cr.vh / cr.scale;
    const c = document.createElement('canvas');
    c.width = Math.round(sw); c.height = Math.round(sh);
    c.getContext('2d').drawImage(imgEl, -cr.x / cr.scale, -cr.y / cr.scale, sw, sh, 0, 0, c.width, c.height);
    setImage(c.toDataURL('image/png'), c.width, c.height, false);
    closeCrop();
  });

  update();
}

/* ---------- Wishlist ---------- */
const WISH_KEY = 'pw-wish';
let wish = [];
try { wish = JSON.parse(localStorage.getItem(WISH_KEY) || '[]').filter((h) => PRODUCTS.some((p) => p.handle === h)); } catch (e) { wish = []; }
const wishHas = (h) => wish.includes(h);
function wishCount() {
  const c = $('#wishCount');
  c.hidden = !wish.length; c.textContent = wish.length;
}
function wishToggle(h) {
  const on = !wishHas(h);
  wish = on ? [...wish, h] : wish.filter((x) => x !== h);
  try { localStorage.setItem(WISH_KEY, JSON.stringify(wish)); } catch (e) { /* storage blocked */ }
  wishCount();
  document.querySelectorAll(`[data-wish="${h}"]`).forEach((b) => { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
  window.__toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist');
  return on;
}

function wishlistPage() {
  const list = wish.map(byHandle).filter(Boolean);
  return `
  ${hero('page', { eyebrow: 'Saved for later', title: 'Your <em>wishlist.</em>', lede: list.length ? `${list.length} ${list.length === 1 ? 'print' : 'prints'} saved in this browser.` : 'Tap the heart on any poster to save it here.' })}
  <div class="wrap">
    ${list.length
      ? `<div class="listhead"><span class="count">${list.length} saved</span><button class="linkbtn" id="wishClear">Clear wishlist</button></div><div class="grid">${list.map(card).join('')}</div>`
      : `<div class="empty-state"><h3>Nothing saved yet</h3><p>Find a poster you love and tap the heart.</p><a class="btn-solid" href="#/collection"><span>Browse the collection</span>${arrow}</a></div>`}
    <div class="pagecta"></div>
  </div>
  ${newsletter()}`;
}

/* ---------- Orders, checkout, tracking ---------- */
const ORDERS_KEY = 'pw-orders';
const PROFILE_KEY = 'pw-profile';
const readJSON = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } };
const writeJSON = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked */ } };
const getOrders = () => readJSON(ORDERS_KEY, []);
const getProfile = () => readJSON(PROFILE_KEY, null);
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const dateStr = (d) => new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

function cartTotals() {
  const sub = cart.reduce((a, l) => a + unit(l) * l.qty, 0);
  const d = discount();
  return { sub, d, off: sub * d, total: sub * (1 - d) };
}

const COUNTRIES = ['United States', 'Canada', 'United Kingdom', 'Australia', 'Germany', 'France', 'Netherlands', 'Ireland', 'New Zealand'];

function summaryHtml() {
  const t = cartTotals();
  return `
    <div class="co-lines">${cart.map((l) => `
      <div class="co-line"><span class="co-line__img"><img src="${l.custom ? l.custom.src : posterURL(l.p)}" alt=""><i>${l.qty}</i></span>
        <div><b>${esc(l.p.title)}</b><small>${esc(lineLabel(l))}</small></div><span>${money(unit(l) * l.qty)}</span></div>`).join('')}</div>
    <div class="co-rows">
      <div><span>Subtotal</span><span>${money(t.sub)}</span></div>
      ${t.d ? `<div><span>Bundle discount (${Math.round(t.d * 100)}%)</span><span>–${money(t.off)}</span></div>` : ''}
      <div><span>Shipping</span><span>Free</span></div>
      <div class="co-total"><span>Total</span><b>${money(t.total)}</b></div>
    </div>`;
}

function checkoutPage() {
  if (!cart.length) {
    return `<div class="wrap section"><h1 class="page-title">Your cart is empty</h1><p class="co-empty">Add a poster before checking out.</p><a class="btn-solid" href="#/collection"><span>Shop posters</span>${arrow}</a></div>`;
  }
  const pr = getProfile() || {};
  const [first = '', ...rest] = (pr.name || '').split(' ');
  return `
  <div class="wrap co">
    <h1 class="page-title">Checkout</h1>
    <div class="co-demo">Demo checkout: no payment is taken and no card details are asked for.</div>
    <div class="co-grid">
      <form class="co-form" id="coForm" novalidate>
        <h2>Contact</h2>
        <label class="fld">Email<input name="email" type="email" required autocomplete="email" value="${esc(pr.email || '')}"></label>
        <h2>Shipping address</h2>
        <div class="fld-row">
          <label class="fld">First name<input name="first" required autocomplete="given-name" value="${esc(first)}"></label>
          <label class="fld">Last name<input name="last" required autocomplete="family-name" value="${esc(rest.join(' '))}"></label>
        </div>
        <label class="fld">Address<input name="address" required autocomplete="address-line1"></label>
        <label class="fld">Apartment, suite, etc. (optional)<input name="apt" autocomplete="address-line2"></label>
        <div class="fld-row">
          <label class="fld">City<input name="city" required autocomplete="address-level2"></label>
          <label class="fld">State / region<input name="region" required autocomplete="address-level1"></label>
          <label class="fld">Postal code<input name="zip" required autocomplete="postal-code"></label>
        </div>
        <label class="fld">Country<select name="country" autocomplete="country-name">${COUNTRIES.map((c) => `<option>${c}</option>`).join('')}</select></label>
        <label class="fld">Phone (optional)<input name="phone" type="tel" autocomplete="tel"></label>
        <h2>Delivery</h2>
        <div class="co-ship"><span><b>Free shipping</b><small>Printed to order, dispatched within 2 days</small></span><span>Arrives ${deliveryRange()}</span></div>
        <div class="co-err" id="coErr" role="alert" hidden></div>
        <button class="btn-solid co-submit" type="submit"><span>Place order (demo)</span>${arrow}</button>
        <p class="co-fine">By placing this demo order you agree to the <a href="#/legal/terms">Terms</a> and <a href="#/legal/refunds">Refund policy</a>.</p>
      </form>
      <aside class="co-sum" aria-label="Order summary"><h2>Order summary</h2>${summaryHtml()}</aside>
    </div>
  </div>`;
}

function mountCheckout() {
  const form = $('#coForm');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(form).entries());
    const missing = ['email', 'first', 'last', 'address', 'city', 'region', 'zip'].filter((k) => !String(f[k] || '').trim());
    const err = $('#coErr');
    form.querySelectorAll('.is-bad').forEach((x) => x.classList.remove('is-bad'));
    if (missing.length || !/^\S+@\S+\.\S+$/.test(f.email || '')) {
      (missing.length ? missing : ['email']).forEach((k) => form.elements[k]?.classList.add('is-bad'));
      err.textContent = missing.length ? 'Please fill in the highlighted fields.' : 'Please enter a valid email address.';
      err.hidden = false;
      form.querySelector('.is-bad')?.focus();
      return;
    }
    const t = cartTotals();
    const orders = getOrders();
    const id = `PW-${String(Date.now()).slice(-6)}${Math.floor(Math.random() * 90 + 10)}`;
    const order = {
      id, date: Date.now(), email: f.email.trim(), total: t.total, discount: t.off,
      name: `${f.first.trim()} ${f.last.trim()}`,
      address: [f.address, f.apt, `${f.city}, ${f.region} ${f.zip}`, f.country].filter((x) => x && x.trim()).join(', '),
      eta: deliveryRange(),
      items: cart.map((l) => ({ title: l.p.title, label: lineLabel(l), qty: l.qty, price: unit(l), handle: l.custom ? null : l.p.handle })),
    };
    writeJSON(ORDERS_KEY, [order, ...orders]);
    if (!getProfile()) writeJSON(PROFILE_KEY, { name: order.name, email: order.email });
    cart.length = 0;
    renderCart();
    location.hash = `#/order/${id}`;
  });
}

function orderPage(id) {
  const o = getOrders().find((x) => x.id === id);
  if (!o) return notFoundPage('We could not find that order in this browser.');
  const first = esc((o.name || '').split(' ')[0] || 'there');
  const addr = esc(o.address);
  return `
  <section class="ty-stage">
    <div class="ty-left">
      <article class="tyl fu-in" aria-label="Thank you letter"><div class="tyl__frame">
        <div class="tyl__head"><img class="tyl__logo" src="${window.PWA('brand/pitwall-mark-ink.png')}" alt="Pitwall"><div class="tyl__ref"><span>Order ${esc(o.id)}</span><span>${dateStr(o.date)}</span></div></div>
        <div class="tyl__orn" aria-hidden="true"><i></i><b>✦</b><i></i></div>
        <h1>Thank you for <em>choosing us.</em></h1>
        <div class="tyl__body">
          <p class="tyl__salute">Dear ${first},</p>
          <p>Your order has reached us safely, and we are honored that you chose to hang a piece of Pitwall on your wall.</p>
          <p>Every poster is printed to order on canvas, and yours will be on its way within two days. We hope it finds the right wall, and that it makes you smile every time you pass it.</p>
        </div>
        <div class="tyl__close"><span class="tyl__with">With gratitude,</span><img class="tyl__sig" src="${window.PWA('brand/pitwall-signature.png')}" alt="Pitwall"><span class="tyl__nm">The Pitwall Team</span></div>
        <p class="tyl__ps"><i>P.S.</i> We will email you the moment it ships.</p>
        <div class="tyl__stamp" aria-hidden="true"><img src="${window.PWA('brand/pitwall-mark-stamp.png')}" alt=""></div>
      </div></article>
    </div>
    <aside class="ty-right" aria-label="Order details">
      <div class="tyr">
        <div><div class="tyr__eyebrow">Your order</div><h2 class="serif">The details</h2></div>
        <div class="tyr__items">${o.items.map((i) => {
          const p = i.handle && byHandle(i.handle);
          return `<div class="tyr__item"><span class="tyr__img">${p ? `<img src="${posterURL(p)}" alt="">` : '<i></i>'}</span><div><b>${esc(i.title)}</b><small>${esc(i.label)} · Qty ${i.qty}</small></div><span>${money(i.price * i.qty)}</span></div>`;
        }).join('')}</div>
        <div class="tyr__sum">
          ${o.discount ? `<div><span>Bundle discount</span><span>–${money(o.discount)}</span></div>` : ''}
          <div><span>Shipping</span><span>Free</span></div>
          <div class="tyr__total"><span>Total</span><b>${money(o.total)}</b></div>
        </div>
        <div class="tyr__info">
          <div><b>Shipping to</b><span>${esc(o.name)}<br>${addr}</span></div>
          <div><b>Estimated arrival</b><span>${esc(o.eta)}</span><small>Printed to order, dispatched within 2 days.</small></div>
          <div><b>Confirmation</b><span>${esc(o.email)}</span><small>We will email you when it ships.</small></div>
        </div>
        <a class="btn-solid tyr__btn" href="#/track?order=${esc(o.id)}"><span>Track this order</span>${arrow}</a>
      </div>
    </aside>
  </section>`;
}

const STEPS = ['Order received', 'Printing', 'Shipped', 'Delivered'];
function trackStatus(o) {
  const days = (Date.now() - o.date) / 86400000;
  return days < 0.04 ? 0 : days < 2 ? 1 : days < 10 ? 2 : 3;
}
function trackPage() {
  return `
  ${hero('page', { eyebrow: 'Order status', title: 'Track your <em>order.</em>', lede: 'Every order email has a View your order button that shows live status and tracking.' })}
  <div class="wrap track">
    <div class="track__card">
      <div class="track__top"><div><b>Sign in to see your orders</b><small>Use the email you ordered with. We send a one-time code, so there is no password to remember.</small></div></div>
      <p class="track__help"><a class="btn-solid" href="/account"><span>View my orders</span>${arrow}</a></p>
      <p class="track__help">Cannot find your order? <a href="#/help/contact">Contact us</a> with your order number and we will look it up.</p>
    </div>
  </div>
  ${newsletter()}`;
}

/* ---------- Account (a profile saved in this browser) ---------- */
function accountPage() {
  const pr = getProfile();
  const orders = getOrders();
  return `
  ${hero('page', { eyebrow: 'Your account', title: pr ? `Hello, <em>${esc(pr.name.split(' ')[0] || 'there')}.</em>` : 'Your <em>account.</em>', lede: 'Your details are saved in this browser only.' })}
  <div class="wrap acct">
    <div class="acct__col">
      <h2 class="serif">${pr ? 'Your details' : 'Save your details'}</h2>
      <form class="acct__form" id="acctForm">
        <label class="fld">Name<input name="name" required autocomplete="name" value="${esc(pr?.name || '')}"></label>
        <label class="fld">Email<input name="email" type="email" required autocomplete="email" value="${esc(pr?.email || '')}"></label>
        <div class="acct__btns"><button class="btn-solid" type="submit"><span>${pr ? 'Update details' : 'Save my details'}</span>${arrow}</button>${pr ? '<button class="linkbtn" type="button" id="acctOut">Clear my details</button>' : ''}</div>
      </form>
      <p class="acct__note">We use these to fill in checkout for you. There is no password, and nothing leaves this browser.</p>
      <div class="acct__links"><a href="#/wishlist">Wishlist (${wish.length})</a><a href="#/track">Track an order</a><a href="#/help/contact">Contact us</a></div>
    </div>
    <div class="acct__col">
      <h2 class="serif">Your orders</h2>
      ${orders.length ? `<ul class="acct__orders">${orders.map((o) => `<li><div><b>${esc(o.id)}</b><small>${dateStr(o.date)} · ${o.items.reduce((a, i) => a + i.qty, 0)} item(s)</small></div><div class="acct__ot"><b>${money(o.total)}</b><a href="#/track?order=${esc(o.id)}">Track</a></div></li>`).join('')}</ul>` : `<div class="empty-state empty-state--sm"><p>No orders yet.</p><a class="btn-solid" href="#/collection"><span>Shop posters</span>${arrow}</a></div>`}
    </div>
  </div>`;
}
function mountAccount() {
  $('#acctForm').addEventListener('submit', (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target).entries());
    writeJSON(PROFILE_KEY, { name: f.name.trim(), email: f.email.trim() });
    window.__toast('Details saved');
    app.innerHTML = accountPage(); mountAccount(); startHero();
  });
  $('#acctOut')?.addEventListener('click', () => { try { localStorage.removeItem(PROFILE_KEY); } catch (err) { /* storage blocked */ } window.__toast('Details cleared'); app.innerHTML = accountPage(); mountAccount(); startHero(); });
}

/* ---------- Legal pages and 404 ---------- */
const LEGAL = {
  privacy: ['Privacy policy', [
    ['What we collect', 'When you order we collect your name, email, shipping address and (optional) phone number so we can print and deliver your poster. For custom posters we also receive the image you upload.'],
    ['How we use it', 'We use your details to process and ship your order, to reply to your messages, and to send order updates. If you join our email list we also send news and offers, and you can unsubscribe at any time.'],
    ['Who we share it with', 'We share only what is needed with the printing and shipping partners who make and deliver your order, and with our payment provider. We do not sell your personal information.'],
    ['Cookies and storage', 'This site stores your cart, wishlist and preferences in your own browser so they are still there when you come back. You can clear them at any time in your browser settings.'],
    ['Your choices', 'You can ask us to see, correct or delete the information we hold about you by sending a message from the Help page.'],
  ]],
  terms: ['Terms of service', [
    ['Orders', 'Every poster is printed to order. When you place an order you are asking us to make it, and we confirm it once it is accepted. Prices are shown in US dollars.'],
    ['Delivery', 'We dispatch within 2 days and delivery usually takes around 10-15 days from your order date. Delivery times are estimates and can be affected by carriers, holidays and customs.'],
    ['Custom posters', 'When you upload an image you confirm that you own it or have permission to print it, and that it does not infringe anyone else\'s rights. We may decline an order if we cannot print the file well or if it is not allowed.'],
    ['Product images', 'Colors on screen can differ slightly from the printed canvas. Brand names and logos belong to their owners, and we are not affiliated with or endorsed by any car manufacturer.'],
    ['Liability', 'To the extent the law allows, our liability for any order is limited to the amount you paid for it. Nothing here limits rights you have under consumer law.'],
  ]],
  refunds: ['Refund policy', [
    ['Lost, damaged or undelivered', 'If your order is lost, arrives damaged, or has not arrived within 30 days, tell us through the Help page and we will refund it or send a replacement. For damage, please include a photo.'],
    ['Made to order', 'Because every poster is printed to order, we cannot accept returns for a change of mind. Please check the size guide and, for custom posters, the preview before you order.'],
    ['How refunds work', 'Approved refunds go back to your original payment method. Your bank may take a few days to show them.'],
    ['Contact us', 'Use the form on the Help page and include your order number so we can find it quickly.'],
  ]],
};
function legalPage(kind) {
  const L = LEGAL[kind];
  if (!L) return notFoundPage();
  return `
  ${hero('page', { eyebrow: 'Legal', title: L[0].replace(/(\S+)$/, '<em>$1</em>'), lede: 'Plain language, no small print.' })}
  <div class="wrap legal">
    <nav class="legal__nav" aria-label="Legal pages">${Object.entries(LEGAL).map(([k, v]) => `<a href="#/legal/${k}" class="${k === kind ? 'is-on' : ''}">${v[0]}</a>`).join('')}</nav>
    <div class="legal__body">${L[1].map(([h, p]) => `<section><h2 class="serif">${h}</h2><p>${p}</p></section>`).join('')}<p class="legal__q">Questions? <a href="#/help/contact">Get in touch</a>.</p></div>
  </div>
  ${newsletter()}`;
}
function notFoundPage(msg) {
  return `<div class="wrap section nf"><div class="eyebrow">404</div><h1 class="serif">Off the <em>track.</em></h1><p>${esc(msg || 'That page does not exist.')}</p><a class="btn-solid" href="#/"><span>Back to the garage</span>${arrow}</a></div>`;
}

/* ---------- router ---------- */
function route() { if (window.PW_NATIVE) return;
  const stash = document.getElementById('pw-contact'); if (stash) document.getElementById('pwHidden').appendChild(stash);
  viewer?.dispose(); viewer = null;
  const [path, query = ''] = (/^#pw-/.test(location.hash) ? '' : location.hash.slice(1)).split('?');
  const parts = (path || '/').split('/').filter(Boolean);
  document.querySelector('.nav').classList.remove('is-open');
  if (parts[0] === 'legal') {
    location.replace({ privacy: '/policies/privacy-policy', terms: '/policies/terms-of-service', refunds: '/policies/refund-policy' }[parts[1]] || '/policies/privacy-policy');
    return;
  }
  if (parts[0] === 'product') {
    app.innerHTML = product(parts[1]);
    mountProduct(parts[1]);
  } else if (parts[0] === 'collection') {
    const qp = new URLSearchParams(query);
    const t = qp.get('theme');
    const b = qp.get('brand');
    state.theme = THEMES.includes(t) ? t : null;
    state.brand = BRANDS.includes(b) ? b : null;
    state.page = 1;
    app.innerHTML = collection();
  } else if (parts[0] === 'bestsellers') {
    app.innerHTML = bestsellers();
  } else if (parts[0] === 'new') {
    app.innerHTML = newIn();
  } else if (parts[0] === 'brands') {
    app.innerHTML = brandsPage();
  } else if (parts[0] === 'about') {
    app.innerHTML = aboutPage();
  } else if (parts[0] === 'wishlist') {
    app.innerHTML = wishlistPage();
  } else if (parts[0] === 'checkout') {
    history.back(); shopifyCheckout(); return;
    app.innerHTML = checkoutPage();
    mountCheckout();
  } else if (parts[0] === 'order') {
    app.innerHTML = orderPage(parts[1]);
  } else if (parts[0] === 'track') {
    app.innerHTML = trackPage();
  } else if (parts[0] === 'account') {
    location.replace('/account'); return;
  } else if (parts[0] === 'legal') {
    app.innerHTML = legalPage(parts[1]);
  } else if (parts[0] === 'custom') {
    location.replace('/#/collection'); return;
  } else if (parts[0] === 'help') {
    app.innerHTML = helpPage();
    mountHelp(parts[1]);
  } else if (!parts.length) {
    app.innerHTML = home(new URLSearchParams(query).get('v'));
  } else {
    app.innerHTML = notFoundPage();
  }
  const key = { '': 'home', collection: 'shop', product: 'shop', custom: 'shop', bestsellers: 'best', new: 'new', brands: 'brands', about: 'about', help: 'help' }[parts[0] || ''] ?? '';
  document.querySelectorAll('.nav [data-nav]').forEach((l) => { l.classList.toggle('is-active', l.dataset.nav === key); l.toggleAttribute('aria-current', l.dataset.nav === key); });
  const prod = parts[0] === 'product' && PRODUCTS.find((x) => x.handle === parts[1]);
  const TITLES = { wishlist: 'Wishlist', checkout: 'Checkout', order: 'Order confirmed', track: 'Track your order', account: 'Your account', legal: 'Legal', collection: 'Automotive posters', custom: 'Custom poster', bestsellers: 'Best sellers', new: 'New in', brands: 'Brands', about: 'About us', help: 'Help' };
  document.title = prod ? `${prod.title} – PITWALL` : TITLES[parts[0]] ? `${TITLES[parts[0]]} – PITWALL` : 'PITWALL – Car Poster Studio';
  startHero();
  startWall();
  if (!(parts[0] === 'help' && parts[1])) scrollTo({ top: 0, behavior: 'instant' });
}

app.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-search]')) openSearch(true);
  const chip = e.target.closest("[data-chip]");
  if (chip) { state.theme = chip.dataset.chip || null; state.page = 1; app.innerHTML = collection(); startHero(); }
  const pg = e.target.closest('[data-page]');
  if (pg) { state.page = +pg.dataset.page; app.innerHTML = collection(); startHero(); scrollTo({ top: 120 }); }
});
app.addEventListener('change', (e) => {
  if (e.target.id === 'brand') { state.brand = e.target.value || null; state.page = 1; app.innerHTML = collection(); startHero(); }
  if (e.target.id === 'sort') { state.sort = e.target.value; app.innerHTML = collection(); startHero(); }
});

/* ---------- dark mode ---------- */
const root = document.documentElement;
const setTheme = (t, save = true) => {
  root.dataset.theme = t;
  const cm = document.querySelector('meta[name="color-scheme"]'); if (cm) cm.content = t === 'dark' ? 'dark' : 'only light';
  $('#themeBtn').setAttribute('aria-label', t === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
  if (save) { try { localStorage.setItem('pw-theme', t); } catch (e) { /* storage blocked */ } }
};
setTheme(root.dataset.theme || 'light', false);
$('#themeBtn').addEventListener('click', () => setTheme(root.dataset.theme === 'dark' ? 'light' : 'dark'));

/* ---------- search ---------- */
const searchEl = $('#search');
const searchInput = $('#searchInput');
const searchOut = $('#searchResults');
const openSearch = (on = true) => {
  searchEl.hidden = !on;
  document.body.style.overflow = on ? 'hidden' : '';
  if (on) { searchInput.value = ''; renderSearch(); searchInput.focus(); } else searchInput.blur();
};
function renderSearch() {
  const q = searchInput.value.trim().toLowerCase();
  const hits = (q ? PRODUCTS.filter((p) => `${p.title} ${p.brand} ${p.model} ${p.variant} ${p.theme} ${p.years} ${p.kw || ''}`.toLowerCase().includes(q)) : PRODUCTS.slice(0, 4)).slice(0, 8);
  searchOut.innerHTML = hits.length
    ? `<div class="search__label">${q ? `${hits.length} result${hits.length === 1 ? '' : 's'}` : 'Popular right now'}</div>` + hits.map((p) => `<a class="search__hit" href="#/product/${p.handle}"><img src="${posterURL(p)}" alt="" draggable="false"><span><b>${p.title}</b><small>${p.brand} · ${p.theme}</small></span><em>From ${money(salePrice(SIZES[0].price))}</em></a>`).join('')
    : `<div class="search__empty">No prints match "${searchInput.value.replace(/</g, '&lt;')}". Try a brand like Porsche or a section like Drifting.</div>`;
}
$('#searchBtn').addEventListener('click', () => openSearch(true));
searchInput.addEventListener('input', renderSearch);
searchEl.addEventListener('click', (e) => { if (e.target === searchEl || e.target.closest('.search__hit') || e.target.closest('#searchClose')) openSearch(false); });
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !searchEl.hidden) openSearch(false);
  if (e.key === '/' && searchEl.hidden && !/input|textarea|select/i.test(document.activeElement?.tagName || '')) { e.preventDefault(); openSearch(true); }
});

// Accounts and wishlist are not built yet, and placeholder links ("#") should say so instead of jumping to the top.
document.querySelector('.header__icons [aria-label="Account"]').addEventListener('click', () => { location.href = '/account'; });
document.querySelector('.header__icons [aria-label="Wishlist"]').addEventListener('click', () => { location.hash = '#/wishlist'; });
document.addEventListener('click', (e) => {
  const w = e.target.closest('[data-wish]');
  if (!w) return;
  e.preventDefault(); e.stopPropagation();
  wishToggle(w.dataset.wish);
  if (location.hash.startsWith('#/wishlist')) { app.innerHTML = wishlistPage(); startHero(); }
}, true);
document.addEventListener('keydown', (e) => {
  if ((e.key === 'Enter' || e.key === ' ') && e.target.matches?.('.card__heart')) { e.preventDefault(); e.target.click(); }
});
app.addEventListener('click', (e) => {
  if (e.target.id === 'wishClear') { wish = []; writeJSON(WISH_KEY, wish); wishCount(); app.innerHTML = wishlistPage(); startHero(); }
});
wishCount();
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href="#"]');
  if (a) { e.preventDefault(); window.__toast('Our social pages are launching soon'); }
});

$('#themeMenu').innerHTML = '<a href="#/collection">All posters</a>' + THEMES.map((t) => `<a href="#/collection?theme=${t}">${t}</a>`).join('');
$('#navToggle').addEventListener('click', () => document.querySelector('.nav').classList.toggle('is-open'));
window.addEventListener('hashchange', route);
initSignupPopup();

// Poster art uses Montserrat; wait for it so canvases render with the right font.
(document.fonts ? Promise.all([document.fonts.load('800 40px Montserrat'), document.fonts.load('500 20px Montserrat')]).catch(() => {}) : Promise.resolve()).then(() => { renderCart(); route(); });
